export const workerType = {
  MACHINES: 'machines',
  FILES: 'files',
  PRODUCTION: 'production',
};

export const workerTypeNames = {
  machines: 'Machine',
  files: 'File',
  production: 'Production',
};

export const workerTypeStatus = {
  Online: 'Online',
  Offline: 'Offline',
  connecting: 'Connecting...',
  Onboarding: 'Setting up...',
  Resetting: 'Resetting...',
  InvalidVersion: 'Update Required',
};

export const workerTypeStatusNames = {
  Online: 'Online',
  Offline: 'Offline',
  Onboarding: 'Onboarding',
  Resetting: 'Resetting',
  InvalidVersion: 'Update Required',
};

export const workerTypeStatusIconColor = {
  Online: 'System/Light/Green',
  Offline: 'Chart/Light/Warning',
  InvalidVersion: 'Chart/Light/Warning',
  updating: 'System/Light/Blue',
  off: 'Chart/Light/Warning',
  issue: 'System/Light/Orange',
  notSetupYet: 'Gray/Light/2',
  connecting: 'Gray/Light/2',
  Onboarding: 'Gray/Light/2',
  Resetting: 'Chart/Light/Warning',
};

export const workerTypeStatusIconName = {
  Online: 'ok',
  Offline: 'stopped',
  InvalidVersion: 'stopped',
  updating: 'updating',
  off: 'off',
  issue: 'issue',
  notSetupYet: 'notSetupYet',
  connecting: 'connecting',
  Onboarding: 'connecting',
  Resetting: 'updating',
};
